module.exports = "/assets/data/0ceab840827dbc1378a0e9aeea4a1418-SW1Y.data.json";